import React from 'react';

class Slide5 extends React.Component {
    constructor(props) {
        super(props);
        this.slide5 = React.createRef();
        this.handleScroll = this.handleScroll.bind(this);
        this.visible = false;
        this.state = {
            selected: 1
        };
    }

    componentDidMount() {
        this.props.custScrollTo(this.slide5.current)
        this.setCarousels();
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }   

    handleScroll() {
        let view = this.slide5.current.getBoundingClientRect();
        const Buffer = 5
        if (view.top <= Buffer) this.visible = true;
        if (this.visible && (view.top >= window.innerHeight / 2)) {
            this.props.closeSlide();
        }
    }
    toggleActive(newtabId) {
        switch (newtabId) {
            case 0:
                this.props.toggleTab(5.1)
                this.setState({ selected: 0 })
                break;
            case 1:
                this.props.toggleTab(5.2)
                this.setState({ selected: 1 })
                break;
            case 2:
                this.props.toggleTab(5.3)
                this.setState({ selected: 2 })
                break;
            default:
                break;
        }
    }
    componentDidUpdate() {

        this.unsetCarousels();
        this.setCarousels();
        
    }

    unsetCarousels() {
        $('.slide5-0__carousel').filter('.slick-initialized').slick('unslick');
        $('.slide5-0__mobile-carousel').filter('.slick-initialized').slick('unslick');
        $('.slide5-1__carousel').filter('.slick-initialized').slick('unslick');
        $('.slide5-1__mobile-carousel').filter('.slick-initialized').slick('unslick');
        $('.slide5-2__carousel').filter('.slick-initialized').slick('unslick');
        $('.slide5-2__mobile-carousel').filter('.slick-initialized').slick('unslick');
    }

    setCarousels() {

        $('[data-toggle="popover"]').popover()

        $('.pres-carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            gtag('event', 'Chevron - Clicked', {
                'event_category': 'Preservation calculator',
                'event_label': 'Chevron – Arrow ' + (nextSlide > currentSlide ? '>' : '<') + ' click',
            });
        });

        $('.pres-carousel').not('.slick-initialized').slick({
            slidesToShow: 1,
            arrows: true,
            dots: true,
            nextArrow: "<button class='slick-next slick-arrow' aria-label='Previous' data-analytics-label='Chevron – Arrow > click' data-analytics-action='Chevron - Clicked' data-analytics-category='Carousel chevron' type='button'>Next</button>",
            prevArrow: "<button class='slick-prev slick-arrow' aria-label='Previous' data-analytics-label='Chevron – Arrow < click' data-analytics-action='Chevron - Clicked' data-analytics-category='Carousel chevron' type='button'>Previous</button>"
        });


    }

    getScreenWidth() {
        return window.innerWidth;
    }
    render() {
        return (
            <div className="container-fluid container-xxl cust-pr-sm-4 cust-pl-sm-65 slide slide-5" ref={this.slide5}>


                {this.props.journey === 1 &&
                    <>

                        <div className="row justify-content-center cust-mb-2">
                            <div className="col-12 col-xl-9 col-xxl-12" >
                                <div className="d-flex justify-content-center justify-content-sm-between w-100 align-items-end">
                                    <h2 className="text-red fw-bold font-size-24 font-size-md-32 font-size-xxl-40 text-center cust-mb-26">{this.props.data?.slide5?.title}</h2>
                                    <a href="https://www.allangray.co.za/contact-us/" target="_blank"
                                        data-analytics-label="Pres tool link – Need to speak to someone"
                                        data-analytics-action="Link - Clicked"
                                        data-analytics-category="Preservation calculator"
                                        onClick={(e) => { this.props.recordAnalytics(e); }}
                                        className="d-none d-sm-block text-decoration-none text-link-blue font-size-12">{this.props.data?.slide5?.contactLinkText}</a>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-sm-3 pt-2 g-2 slide5__header-row">
                            <div className="col-4 col-xl-3 col-xxl-4">
                                <div className={"slide5__header" + (this.state.selected === 0 ? " slide5__header--active" : "")} onClick={() => this.toggleActive(0)}>
                                    {this.getScreenWidth() <= 578 ? "Transfer" : "Transfer your investment"}
                                </div>
                            </div>
                            <div className="col-4 col-xl-3 col-xxl-4">
                                <div className={"slide5__header" + (this.state.selected === 1 ? " slide5__header--active" : "")} onClick={() => this.toggleActive(1)}>
                                    Remain&nbsp;invested
                                </div>
                            </div>
                            <div className="col-4 col-xl-3 col-xxl-4">
                                <div className={"slide5__header" + (this.state.selected === 2 ? " slide5__header--active" : "")} onClick={() => this.toggleActive(2)}>
                                    {this.getScreenWidth() <= 578 ? "Withdraw" : "Withdraw from your investment"}
                                </div>
                            </div>
                        </div>
                        {this.state.selected === 0 && <div className='row justify-content-center'>
                            {/*Mobile carousel*/}
                            <div className="row cust-pb-sm-6">
                                <div className="col-12 d-flex justify-content-center align-items-center d-sm-none pt-25">
                                    <p className="text-grey font-size-10 cust-mb-15">Tap the icons for more information</p>
                                </div>
                                <div className="col-12 justify-content-center d-flex d-sm-none slide5-0__mobile-carousel slide5__mobile-carousel pres-carousel">
                                    {this.props.data?.slide5?.transfer?.iconList.map((item, index) => (
                                        <div className={"flip-card"} key={index}>
                                            <div className="flip-card-inner">
                                                <div className="slide5__image--block d-flex align-items-center flip-card-front flex-column">
                                                    <img src={item.url} alt={item.title} className='cust-mb-1' />
                                                    <strong className="text-grey text-center font-size-16 max-width-160" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.title) }}></strong>
                                                </div>

                                                <div className="flip-card-back d-flex align-items-center justify-content-center">
                                                    <p className="text-back font-size-12 mb-0">{item.backText}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/*Desktop list*/}
                            <div className="flex-row justify-content-center d-none d-sm-flex">
                                {this.props?.data?.slide5?.transfer?.iconList?.map((item, index) => (
                                    <div className={"flip-card" + (index == 1 ? "" : " mx-3")} key={index}>
                                        <div className="flip-card-inner">
                                            <div className="slide5__image--block d-flex align-items-center flip-card-front flex-column">
                                                <img src={item.url} alt={item.title} />
                                                <strong className="text-grey text-center font-size-16 max-width-160" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.title) }}></strong>
                                            </div>

                                            <div className="flip-card-back d-flex align-items-center justify-content-center">
                                                <p className="text-back font-size-12 mb-0" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.backText) }}></p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="row justify-content-center cust-mt-3 cust-mt-lg-6">
                                <div className="col-12 col-md-6 col-lg-5">
                                    <div className="slide5-0__carousel slide5__carousel pres-carousel" >
                                        {this.props.data?.slide5?.transfer?.carousel.map((card, index) => (
                                            <div className="" key={index}>
                                                <h3 className="text-red text-center font-size-16 cust-mb-24">Things to keep in mind</h3>
                                                <p className="text-grey fw-bold font-size-14 text-center cust-mb-1">{card.subheading}</p>
                                                <p className="text-grey font-size-14 text-center cust-mb-3" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(card.content) }}></p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="d-none d-sm-block col-12 col-sm-5 col-md-4 col-lg-4 slide5-0__text cust-ml-md-65 cust-ml-lg-4 cust-ml-xl-10 cust-ml-sm-35">
                                    <p className="text-grey font-size-14">
                                        If you do not wish to remain in your Umbrella Retirement Fund investment but want to remain invested, you can transfer your investment to the <a
                                            role="button"
                                            tabIndex={-1}
                                            data-toggle="popover"
                                            data-bs-template="<div class='popover in slide3__popover slide3__popover--lg' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                            data-bs-html="true"
                                            data-bs-trigger="focus"
                                            data-bs-placement="bottom"
                                            data-bs-content="<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span>
                                <p class='font-size-18 fw-bold text-white mt-0'>Allan Gray Pension or Provident Preservation Fund</p><p class='text-white mb-0'>You can transfer your retirement savings in your Umbrella Retirement Fund account to an Allan Gray Preservation Fund account to preserve and grow your money until you retire. The rules around accessing your money will remain in place, but different investment fees apply. However, you cannot add to your retirement savings in a preservation fund. If you want to continue adding to your retirement savings, you can separately start another investment, such as a retirement annuity.<br /><br />Alternatively, you can transfer your investment to the Allan Gray Retirement Annuity, but note that you will sacrifice your ability to make a withdrawal, as the rules of the product are different to the Umbrella Retirement Fund.</p>">
                                            <span className="text-decoration-underline font-size-14">Allan Gray Pension or Provident Preservation Fund</span>
                                            <sup className="font-size-12">?</sup>
                                        </a>. The minimum lump sum required to transfer to a different Allan Gray product is R50 000.
                                    </p>
                                    <p className="text-grey font-size-14">
                                        You may also move to a retirement product offered by another financial services provider or transfer to your new employer’s retirement fund.
                                    </p>
                                </div>
                            </div>
                            <div className="row justify-content-center  pt-4 d-sm-none">
                                <div className="col-12 col-lg-5 col-xxl-5">
                                    <p className="text-grey font-size-12">
                                        If you do not wish to remain in your Umbrella Retirement Fund investment but want to remain invested, you can transfer your investment to the <a
                                            role="button"
                                            tabIndex={-1}
                                            data-toggle="popover"
                                            data-bs-template="<div class='popover in slide3__popover slide3__popover--lg' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                            data-bs-html="true"
                                            data-bs-trigger="focus"
                                            data-bs-placement="bottom"
                                            data-bs-content="<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span>
                                <p class='font-size-18 fw-bold text-white mt-0'>Allan Gray Pension or Provident Preservation Fund</p><p class='text-white mb-0'>You can transfer your retirement savings in your Umbrella Retirement Fund account to an Allan Gray Preservation Fund account to preserve and grow your money until you retire. The rules around accessing your money will remain in place, but different investment fees apply. However, you cannot add to your retirement savings in a preservation fund. If you want to continue adding to your retirement savings, you can separately start another investment, such as a retirement annuity.<br /><br />Alternatively, you can transfer your investment to the Allan Gray Retirement Annuity, but note that you will sacrifice your ability to make a withdrawal, as the rules of the product are different to the Umbrella Retirement Fund.</p>">
                                            <span className="text-decoration-underline font-size-12">Allan Gray Pension or Provident Preservation Fund</span>
                                            <sup className="font-size-12" style={{ top: "-0.25em" }}>?</sup>
                                        </a>. The minimum lump sum required to transfer to a different Allan Gray product is R50 000.
                                    </p>
                                    <p className="text-grey font-size-12">
                                        You may also move to a retirement product offered by another financial services provider or transfer to your new employer’s retirement fund.
                                    </p>
                                </div>
                            </div>
                            <div className="row justify-content-center cta-row cust-mt-5">
                                <div className='col-0 col-sm-6'></div>
                                <div className="col-12 col-sm-6">
                                    <div className="slide5__btn justify-content-end">
                                        <a
                                            className="btn btn-primary btn-red mb-4 btn--greytext"
                                            data-analytics-label="Pres tool button – Transfer my investment"
                                            data-analytics-action="Button - Clicked"
                                            data-analytics-category="Preservation calculator"
                                            onClick={(e) => { this.props.recordAnalytics(e); }}
                                            target={'_blank'}
                                            href={this.props.data?.slide5?.transfer?.ctaUrl}
                                            type="button" >{this.props.data?.slide5?.transfer?.cta}</a>
                                    </div>
                                </div>
                            </div>
                        </div >}
                        {this.state.selected === 1 && <div className='row justify-content-center'>
                            {/*Mobile carousel*/}
                            <div className="row cust-pb-sm-6">
                                <div className="col-12 d-flex justify-content-center align-items-center d-sm-none pt-25">
                                    <p className="text-grey font-size-10 cust-mb-15">Tap the icons for more information</p>
                                </div>
                                <div className="col-12 justify-content-center d-flex d-sm-none slide5-1__mobile-carousel slide5__mobile-carousel pres-carousel">
                                    {this.props.data?.slide5?.remainInvested?.iconList.map((item, index) => (
                                        <div className={"flip-card"} key={index}>
                                            <div className="flip-card-inner">
                                                <div className="slide5__image--block d-flex align-items-center flip-card-front flex-column">
                                                    <img src={item.url} alt={item.title} className='cust-mb-1' />
                                                    <strong className="text-grey text-center font-size-16 max-width-160" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.title) }}></strong>
                                                </div>

                                                <div className="flip-card-back d-flex align-items-center justify-content-center">
                                                    <p className="text-back font-size-12 mb-0" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.backText) }}></p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/*Mobile carousel end*/}
                            {/*Desktop list*/}
                            <div className="flex-row justify-content-center d-none d-sm-flex">
                                {this.props.data?.slide5?.remainInvested?.iconList?.map((item, index) => (
                                    <div className={"flip-card" + (index == 1 ? "" : " mx-3")} key={index}>
                                        <div className="flip-card-inner">
                                            <div className="slide5__image--block d-flex align-items-center flip-card-front flex-column">
                                                <img src={item.url} alt={item.title} />
                                                <strong className="text-grey text-center font-size-16 max-width-160" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.title) }}></strong>
                                            </div>

                                            <div className="flip-card-back d-flex align-items-center justify-content-center">
                                                <p className="text-back font-size-12 mb-0" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.backText) }}></p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="row justify-content-center cust-mt-3 cust-mt-lg-6">
                                <div className="col-12 col-md-6 col-lg-5">
                                    <div className="slide5-1__carousel slide5__carousel pres-carousel" >
                                        {this.props.data?.slide5?.remainInvested?.carousel?.map((card, index) => (
                                            <div className="" key={index}>
                                                <h3 className="text-red text-center font-size-16 cust-mb-24">Things to keep in mind</h3>
                                                <p className="text-grey fw-bold font-size-14 text-center cust-mb-1">{card.subheading}</p>
                                                <p className="text-grey font-size-14 text-center cust-mb-3" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(card.content) }}></p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="d-none d-sm-block col-12 col-sm-5 col-md-4 col-lg-4 slide5-1__text cust-ml-sm-35 cust-ml-md-65 cust-ml-lg-4 cust-ml-xl-10">
                                    <h3 className="text-red font-size-16">Your Allan Gray Online account lets you:</h3>
                                    <ul className="text-decoration-none text-grey font-size-md-14 mb-25">
                                        <li>Update your contact details and nominees</li>
                                        <li>View and manage your investments securely</li>
                                        <li>Avoid printing, signing and emailing forms</li>
                                    </ul>
                                    <p className="text-grey font-size-md-14" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(this.props.data?.slide5?.remainInvested?.educationText) }}></p>
                                </div>
                            </div>
                            <div className="row justify-content-center  cust-mt-sm-4 d-sm-none">
                                <div className="col-12 col-lg-5 col-xxl-5 px-5">
                                    <h3 className="text-red font-size-16">Your Allan Gray Online account lets you:</h3>
                                    <ul className="text-decoration-none text-grey font-size-12 font-size-md-14 mb-20">
                                        <li>Update your contact details and nominees</li>
                                        <li>View and manage your investments securely</li>
                                        <li>Avoid printing, signing and emailing forms</li>
                                    </ul>
                                    <p className="text-grey font-size-12" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(this.props.data?.slide5?.remainInvested?.educationText) }}></p>
                                </div>
                            </div>
                            <div className="row justify-content-center cta-row cust-mt-5">
                                <div className='col-0 col-sm-6'></div>
                                <div className="col-12 col-sm-6">
                                    <div className="slide5__btn justify-content-end">
                                        <a
                                            className="btn btn-primary btn-red mb-4 btn--greytext"
                                            data-analytics-label="Pres tool button – Log in"
                                            data-analytics-action="Button - Clicked"
                                            data-analytics-category="Preservation calculator"
                                            onClick={(e) => { this.props.recordAnalytics(e); }}
                                            type="button"
                                            target={'_blank'}
                                            rel="noopener"
                                            href={this.props.data?.slide5?.remainInvested?.ctaUrl}
                                        >{this.props.data?.slide5?.remainInvested?.cta}</a>
                                    </div>
                                </div>
                            </div>
                        </div >}
                        {this.state.selected === 2 && <div className='row justify-content-center'>

                            {/*Mobile carousel*/}
                            <div className="row cust-pb-sm-6">
                                <div className='col-12 d-flex justify-content-center align-items-center d-sm-none slide5__subtitle'>
                                    <h5 className="text-red text-center font-size-16">Reasons this option may not be suitable for you:</h5>
                                </div>
                                <div className="col-12 d-flex justify-content-center align-items-center d-sm-none">
                                    <p className="text-grey font-size-10 cust-mb-15">Tap the icons for more information</p>
                                </div>
                                <div className="col-12 justify-content-center d-flex d-sm-none slide5-2__mobile-carousel slide5__mobile-carousel pres-carousel">
                                    {this.props.data?.slide5?.withdraw?.iconList.map((item, index) => (
                                        <div className={"flip-card"} key={index}>
                                            <div className="flip-card-inner">
                                                <div className="slide5__image--block d-flex align-items-center flip-card-front flex-column">
                                                    <img src={item.url} alt={item.title} className='cust-mb-1' />
                                                    <strong className="text-grey text-center font-size-16 max-width-160" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.title) }}></strong>
                                                </div>

                                                <div className="flip-card-back d-flex align-items-center justify-content-center">
                                                    <p className="text-back font-size-12 mb-0" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.backText) }}></p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/*Desktop list*/}
                            <div className='col-12 d-flex justify-content-center align-items-center d-none d-sm-flex slide5__subtitle'>
                                <h5 className="text-red text-center">Reasons this option may not be suitable for you:</h5>
                            </div>
                            <div className="flex-row justify-content-center d-none d-sm-flex">
                                {this.props.data?.slide5?.withdraw?.iconList.map((item, index) => (
                                    <div className={"flip-card" + (index == 1 ? "" : " mx-3")} key={index}>
                                        <div className="flip-card-inner">
                                            <div className="slide5__image--block d-flex align-items-center flip-card-front flex-column">
                                                <img src={item.url} alt={item.title} />
                                                <strong className="text-grey text-center font-size-16 max-width-160" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.title) }}></strong>
                                            </div>

                                            <div className="flip-card-back d-flex align-items-center justify-content-center">
                                                <p className="text-back font-size-12 mb-0" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.backText) }}></p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="row justify-content-center cust-mt-3 cust-mt-lg-6">
                                <div className="col-12 col-md-6 col-lg-5">
                                    <div className="slide5-2__carousel slide5__carousel pres-carousel" >
                                        {this.props.data?.slide5?.withdraw?.carousel.map((card, index) => (
                                            <div className="" key={index}>
                                                <h3 className="text-red text-center font-size-16 cust-mb-24">Things to keep in mind</h3>
                                                <p className="text-grey fw-bold font-size-14 text-center cust-mb-1">{card.subheading}</p>
                                                <p className="text-grey font-size-14 text-center cust-mb-3" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(card.content) }}></p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {/*Desktop */}

                                <div className="d-none d-sm-block col-12 col-sm-5 col-md-4 col-lg-4 slide5-2__text cust-ml-md-65 cust-ml-lg-4 cust-ml-xl-10 cust-ml-sm-35">
                                    <p className="text-grey fw-bold font-size-14">Keep as much as you can invested</p>                                
                                    <p className="text-grey font-size-14" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(this.props.data?.slide5?.withdraw?.educationText) }}></p>
                                    <span
                                        data-analytics-label="Pres tool button – Withdraw a portion"
                                        data-analytics-action="Button - Clicked"
                                        data-analytics-category="Preservation calculator"
                                        className="d-none d-sm-block text-decoration-none font-size-14 text-link-blue mt-6 cursor-pointer font-roboto" onClick={(e) => { this.props.goToSlide4(); this.props.recordAnalytics(e); }}>See what happens if you withdraw a portion.</span>
                                </div>
                            </div>
                            {/*Mobile */}
                            <div className="row justify-content-center  cust-mt-sm-4 pt-4 d-sm-none">
                                <div className="col-12 col-lg-5 col-xxl-5">
                                    <p className="text-grey fw-bold font-size-14">Keep as much as you can invested</p>                                    
                                    <p className="text-grey font-size-12" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(this.props.data?.slide5?.withdraw?.educationText) }}></p>
                                    <span
                                        data-analytics-label="Pres tool button – Withdraw a portion"
                                        data-analytics-action="Button - Clicked"
                                        data-analytics-category="Preservation calculator"
                                        className="d-sm-none text-decoration-none text-link-blue font-size-12 mt-5 cursor-pointer font-roboto fw-bold" onClick={(e) => { this.props.goToSlide4(); this.props.recordAnalytics(e); }}>See what happens if you withdraw a portion.</span>
                                </div>
                            </div>

                            <div className="row justify-content-center cta-row cust-mt-5">
                                <div className='col-0 col-sm-6'></div>
                                <div className="col-12 col-sm-6">
                                    <div className="slide5__btn justify-content-end">
                                        <a
                                            className="btn btn-primary btn-red mb-4 btn--greytext"
                                            data-analytics-label="Pres tool button – Withdraw from my savings component"
                                            data-analytics-action="Button - Clicked"
                                            data-analytics-category="Preservation calculator"
                                            onClick={(e) => { this.props.recordAnalytics(e); }}
                                            target={'_blank'}
                                            rel="noopener"
                                            href={this.props.data?.slide5?.withdraw?.ctaUrl}
                                            type="button" >{this.props?.data?.slide5?.withdraw?.cta}</a>
                                    </div>

                                    <div className="slide5__btn justify-content-end">
                                        <a
                                            className="btn btn-tertiary btn-red mb-4"
                                            data-analytics-label="Pres tool button – Withdraw my investment"
                                            data-analytics-action="Button - Clicked"
                                            data-analytics-category="Preservation calculator"
                                            onClick={(e) => { this.props.recordAnalytics(e); }}
                                            target={'_blank'}
                                            rel="noopener"
                                            href={this.props?.data?.slide5?.withdraw?.ctaSecondaryUrl}
                                            type="button">{this.props?.data?.slide5?.withdraw?.ctaSecondary}</a>
                                    </div>
                                </div>
                            </div>

                        </div >}
                    </>
                }

                {this.props.journey === 2 &&
                    <>
                        <div className="row justify-content-center cust-mb-2">
                            <div className="col-12 col-xl-9 col-xxl-12" >
                                <div className="d-flex justify-content-center justify-content-sm-between w-100 align-items-end">
                                    <h2 className="text-red fw-bold font-size-24 font-size-md-32 font-size-xxl-40 text-center cust-mb-26">{this.props.data?.savingsComponent?.slide5?.title}</h2>
                                    <a href="https://www.allangray.co.za/contact-us/" target="_blank" rel="noopener"
                                        data-analytics-label="Pres tool link – Need to speak to someone"
                                        data-analytics-action="Link - Clicked"
                                        data-analytics-category="Preservation calculator"
                                        onClick={(e) => { this.props.recordAnalytics(e); }}
                                        className="d-none d-sm-block text-decoration-none text-link-blue font-size-12">{this.props.data?.savingsComponent?.slide5?.contactLinkText}</a>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-sm-3 pt-2 g-2 slide5__header-row">

                            <div className="col-4 col-xl-3 col-xxl-4">
                                <div className={"slide5__header" + (this.state.selected === 1 ? " slide5__header--active" : "")} onClick={() => this.toggleActive(1)}>
                                    Remain&nbsp;invested
                                </div>
                            </div>
                            <div className="col-4 col-xl-3 col-xxl-4">
                                <div className={"slide5__header" + (this.state.selected === 2 ? " slide5__header--active" : "")} onClick={() => this.toggleActive(2)}>
                                    {this.getScreenWidth() <= 578 ? "Withdraw" : "Withdraw from your investment"}
                                </div>
                            </div>
                        </div>
                        {this.state.selected === 1 && <div className='row justify-content-center'>
                            {/*Mobile carousel*/}
                            <div className="row cust-pb-sm-6">
                                <div className="col-12 d-flex justify-content-center align-items-center d-sm-none pt-25">
                                    <p className="text-grey font-size-10 cust-mb-15">Tap the icons for more information</p>
                                </div>
                                <div className="col-12 justify-content-center d-flex d-sm-none slide5-1__mobile-carousel slide5__mobile-carousel pres-carousel">
                                    {this.props.data?.savingsComponent.slide5?.remainInvested?.iconList.map((item, index) => (
                                        <div className={"flip-card"} key={index}>
                                            <div className="flip-card-inner">
                                                <div className="slide5__image--block d-flex align-items-center flip-card-front flex-column">
                                                    <img src={item.url} alt={item.title} className='cust-mb-1' />
                                                    <strong className="text-grey text-center font-size-16 max-width-160" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.title) }}></strong>
                                                </div>

                                                <div className="flip-card-back d-flex align-items-center justify-content-center">
                                                    <p className="text-back font-size-12 mb-0" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.backText) }}></p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/*Mobile carousel end*/}
                            {/*Desktop list*/}
                            <div className="flex-row justify-content-center d-none d-sm-flex">
                                {this.props.data?.savingsComponent.slide5?.remainInvested?.iconList?.map((item, index) => (
                                    <div className={"flip-card" + (index == 1 ? "" : " mx-3")} key={index}>
                                        <div className="flip-card-inner">
                                            <div className="slide5__image--block d-flex align-items-center flip-card-front flex-column">
                                                <img src={item.url} alt={item.title} />
                                                <strong className="text-grey text-center font-size-16 max-width-160" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.title) }}></strong>
                                            </div>

                                            <div className="flip-card-back d-flex align-items-center justify-content-center">
                                                <p className="text-back font-size-12 mb-0" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.backText) }}></p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="row justify-content-center cust-mt-3 cust-mt-lg-6">
                                <div className="col-12 col-md-6 col-lg-5">
                                    <div className="slide5-1__carousel slide5__carousel pres-carousel" >
                                        {this.props.data?.savingsComponent.slide5?.remainInvested?.carousel?.map((card, index) => (
                                            <div className="" key={index}>
                                                <h3 className="text-red text-center font-size-16 cust-mb-24">Things to keep in mind</h3>
                                                <p className="text-grey fw-bold font-size-14 text-center cust-mb-1">{card.subheading}</p>
                                                <p className="text-grey font-size-14 text-center cust-mb-3" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(card.content) }}></p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="d-none d-sm-block col-12 col-sm-5 col-md-4 col-lg-4 slide5-1__text cust-ml-sm-35 cust-ml-md-65 cust-ml-lg-4 cust-ml-xl-10">
                                    <h3 className="text-red font-size-16">Your Allan Gray Online account lets you:</h3>
                                    <ul className="text-decoration-none text-grey font-size-md-14 mb-25">
                                        <li>Update your contact details and nominees</li>
                                        <li>View and manage your investments securely</li>
                                        <li>Avoid printing, signing and emailing forms</li>
                                    </ul>
                                    <p className="text-grey font-size-md-14" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(this.props.data?.savingsComponent.slide5?.remainInvested?.educationText) }}></p>
                                </div>
                            </div>
                            <div className="row justify-content-center  cust-mt-sm-4 d-sm-none">
                                <div className="col-12 col-lg-5 col-xxl-5 px-5">
                                    <h3 className="text-red font-size-16">Your Allan Gray Online account lets you:</h3>
                                    <ul className="text-decoration-none text-grey font-size-12 font-size-md-14 mb-20">
                                        <li>Update your contact details and nominees</li>
                                        <li>View and manage your investments securely</li>
                                        <li>Avoid printing, signing and emailing forms</li>
                                    </ul>
                                    <p className="text-grey font-size-12" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(this.props.data?.savingsComponent.slide5?.remainInvested?.educationText) }}></p>
                                </div>
                            </div>
                            <div className="row justify-content-center cta-row cust-mt-5">
                                <div className='col-0 col-sm-6'></div>
                                <div className="col-12 col-sm-6">
                                    <div className="slide5__btn justify-content-end">
                                        <a
                                            className="btn btn-primary btn-red mb-4 btn--greytext"
                                            data-analytics-label="Pres tool button – Log in"
                                            data-analytics-action="Button - Clicked"
                                            data-analytics-category="Preservation calculator"
                                            onClick={(e) => { this.props.recordAnalytics(e); }}
                                            type="button"
                                            target={'_blank'}
                                            rel="noopener"
                                            href={this.props.data?.savingsComponent.slide5?.remainInvested?.ctaUrl}
                                        >{this.props.data?.savingsComponent.slide5?.remainInvested?.cta}</a>
                                    </div>
                                </div>
                            </div>
                        </div >}
                        {this.state.selected === 2 && <div className='row justify-content-center'>

                            {/*Mobile carousel*/}
                            <div className="row cust-pb-sm-6">
                                <div className='col-12 d-flex justify-content-center align-items-center d-sm-none slide5__subtitle'>
                                    <h5 className="text-red text-center font-size-16">Reasons this option may not be suitable for you:</h5>
                                </div>
                                <div className="col-12 d-flex justify-content-center align-items-center d-sm-none">
                                    <p className="text-grey font-size-10 cust-mb-15">Tap the icons for more information</p>
                                </div>
                                <div className="col-12 justify-content-center d-flex d-sm-none slide5-2__mobile-carousel slide5__mobile-carousel pres-carousel">
                                    {this.props.data?.savingsComponent.slide5?.withdraw?.iconList.map((item, index) => (
                                        <div className={"flip-card"} key={index}>
                                            <div className="flip-card-inner">
                                                <div className="slide5__image--block d-flex align-items-center flip-card-front flex-column">
                                                    <img src={item.url} alt={item.title} className='cust-mb-1' />
                                                    <strong className="text-grey text-center font-size-16 max-width-160" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.title) }}></strong>
                                                </div>

                                                <div className="flip-card-back d-flex align-items-center justify-content-center">
                                                    <p className="text-back font-size-12 mb-0" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.backText) }}></p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/*Desktop list*/}
                            <div className='col-12 d-flex justify-content-center align-items-center d-none d-sm-flex slide5__subtitle'>
                                <h5 className="text-red text-center">Reasons this option may not be suitable for you:</h5>
                            </div>
                            <div className="flex-row justify-content-center d-none d-sm-flex">
                                {this.props.data?.savingsComponent.slide5?.withdraw?.iconList.map((item, index) => (
                                    <div className={"flip-card" + (index == 1 ? "" : " mx-3")} key={index}>
                                        <div className="flip-card-inner">
                                            <div className="slide5__image--block d-flex align-items-center flip-card-front flex-column">
                                                <img src={item.url} alt={item.title} />
                                                <strong className="text-grey text-center font-size-16 max-width-160" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.title) }}></strong>
                                            </div>

                                            <div className="flip-card-back d-flex align-items-center justify-content-center">
                                                <p className="text-back font-size-12 mb-0" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(item.backText) }}></p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="row justify-content-center cust-mt-3 cust-mt-lg-6">
                                <div className="col-12 col-md-6 col-lg-5">
                                    <div className="slide5-2__carousel slide5__carousel pres-carousel" >
                                        {this.props.data?.savingsComponent.slide5?.withdraw?.carousel.map((card, index) => (
                                            <div className="" key={index}>
                                                <h3 className="text-red text-center font-size-16 cust-mb-24">Things to keep in mind</h3>
                                                <p className="text-grey fw-bold font-size-14 text-center cust-mb-1">{card.subheading}</p>
                                                <p className="text-grey font-size-14 text-center cust-mb-3" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(card.content) }}></p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {/*Desktop */}

                                <div className="d-none d-sm-block col-12 col-sm-5 col-md-4 col-lg-4 slide5-2__text cust-ml-md-65 cust-ml-lg-4 cust-ml-xl-10 cust-ml-sm-35">
                                    <p className="text-grey fw-bold font-size-14">Keep as much as you can invested</p>                                
                                    <p className="text-grey font-size-14" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(this.props.data?.savingsComponent.slide5?.withdraw?.educationText) }}></p>
                                    <span
                                        data-analytics-label="Pres tool button – Withdraw a portion"
                                        data-analytics-action="Button - Clicked"
                                        data-analytics-category="Preservation calculator"
                                        className="d-none d-sm-block text-decoration-none font-size-14 text-link-blue mt-6 cursor-pointer font-roboto" onClick={(e) => { this.props.goToSlide4(); this.props.recordAnalytics(e); }}>See what happens if you withdraw a portion.</span>
                                </div>
                            </div>
                            {/*Mobile */}
                            <div className="row justify-content-center  cust-mt-sm-4 pt-4 d-sm-none">
                                <div className="col-12 col-lg-5 col-xxl-5">
                                    <p className="text-grey fw-bold font-size-14">Keep as much as you can invested</p>                                 
                                    <p className="text-grey font-size-12" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(this.props.data?.savingsComponent.slide5?.withdraw?.educationText) }}></p>
                                    <span
                                        data-analytics-label="Pres tool button – Withdraw a portion"
                                        data-analytics-action="Button - Clicked"
                                        data-analytics-category="Preservation calculator"
                                        className="d-sm-none text-decoration-none text-link-blue font-size-12 mt-5 cursor-pointer font-roboto fw-bold" onClick={(e) => { this.props.goToSlide4(); this.props.recordAnalytics(e); }}>See what happens if you withdraw a portion.</span>
                                </div>
                            </div>

                            <div className="row justify-content-center cta-row cust-mt-5">
                                <div className='col-0 col-sm-6'></div>
                                <div className="col-12 col-sm-6">
                                    <div className="slide5__btn justify-content-end">
                                        <a
                                            className="btn btn-primary btn-red mb-4 btn--greytext"
                                            data-analytics-label="Pres tool button – Withdraw from my savings component"
                                            data-analytics-action="Button - Clicked"
                                            data-analytics-category="Preservation calculator"
                                            onClick={(e) => { this.props.recordAnalytics(e); }}
                                            target={'_blank'}  
                                            rel="noopener"                                        
                                            href={this.props.data?.savingsComponent.slide5?.withdraw?.ctaUrl}
                                            type="button" >{this.props?.data?.savingsComponent.slide5?.withdraw?.cta}</a>
                                    </div>
                                </div>
                            </div>

                        </div >}
                    </>
                }





                <div className='container cust-pb-6 cust-pt-4 d-sm-none'>
                    <div className="row justify-content-center">
                        <div className="col-11 col-xl-10 d-flex justify-content-center">
                            <a href="https://www.allangray.co.za/contact-us/"
                                target="_blank" 
                                rel="noopener"
                                data-analytics-label="Pres tool link – Need to speak to someone"
                                data-analytics-action="Link - Clicked"
                                data-analytics-category="Preservation calculator"
                                onClick={(e) => { this.props.recordAnalytics(e); }}
                                className="text-decoration-none text-link-blue font-size-12">Need to speak to someone?</a>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-11 col-xl-10">
                            <p className="cust-mt-6 text-grey fw-light font-size-11 lh-20 slide-5__copyright">
                                <span dangerouslySetInnerHTML={{ __html: this.props.removePtags(this.props.sanitizeHTML(this.props?.data?.copyrightText)) }}></span>
                                <span data-bs-toggle="modal" data-bs-target="#infoModal" className="text-decoration-none text-link-blue hover-underline"> {this.props?.data?.copyrightLink}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Slide5;

